
import { lazy } from "react";
import NotFound from "@/pages/NotFound";

// Preload critical pages to prevent import failures
const Index = lazy(() => import("@/pages/Index"));
const About = lazy(() => import("@/pages/About"));

// Eagerly preload blog components to prevent chunking issues
const Blog = lazy(() => {
  const importPromise = import("@/pages/Blog");
  // Add a catch handler to provide better error reporting
  importPromise.catch(err => {
    console.error("Failed to load Blog component:", err);
  });
  return importPromise;
});

const BlogPost = lazy(() => {
  const importPromise = import("@/pages/BlogPost");
  importPromise.catch(err => {
    console.error("Failed to load BlogPost component:", err);
  });
  return importPromise;
});

// Lazy load remaining components
const CaseStudies = lazy(() => import("@/pages/CaseStudies"));
const GetStarted = lazy(() => import("@/pages/GetStarted"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Sitemap = lazy(() => import("@/pages/Sitemap"));
const DynamicSitemap = lazy(() => import("@/pages/DynamicSitemap"));
const Careers = lazy(() => import("@/pages/Careers"));
const HowTo = lazy(() => import("@/pages/resources/HowTo"));

// Core application routes
export const coreRoutes = [
  {
    path: "/",
    element: <Index />
  },
  {
    path: "/about",
    element: <About />
  },
  {
    path: "/case-studies",
    element: <CaseStudies />
  },
  {
    path: "/blog",
    element: <Blog />
  },
  {
    path: "/blog/:slug",
    element: <BlogPost />
  },
  {
    path: "/get-started",
    element: <GetStarted />
  },
  {
    path: "/privacy",
    element: <Privacy />
  },
  {
    path: "/sitemap",
    element: <Sitemap />
  },
  {
    path: "/sitemap.xml",
    element: <DynamicSitemap />
  },
  {
    path: "/careers",
    element: <Careers />
  },
  {
    path: "/resources/how-to",
    element: <HowTo />
  },
  {
    path: "*",
    element: <NotFound />
  }
];
